/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs */

const en_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When your focus is clear, the path lights itself.`)
};

const ar_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عندما يتضح تركيزك، ينير الدرب نفسه.`)
};

const de_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn dein Fokus klar ist, erleuchtet sich der Weg von selbst.`)
};

const es_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando tu enfoque es claro, el camino se ilumina por sí solo.`)
};

const fr_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsque votre concentration est claire, le chemin s'éclaire de lui-même.`)
};

const it_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando la tua concentrazione è chiara, il cammino si illumina da sé.`)
};

const ja_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中が研ぎ澄まされるとき、進むべき道は自ずと照らされます。`)
};

const ko_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중이 명확해질 때, 길은 저절로 밝게 비춰집니다.`)
};

const pt_br_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando seu foco é claro, o caminho se ilumina por si só.`)
};

const ru_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда ваш фокус ясен, путь озаряется сам собой.`)
};

const th_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมื่อสมาธิของคุณชัดเจน หนทางข้างหน้าจะสว่างไสวขึ้นมาเอง`)
};

const tr_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanman netleştiğinde, yol kendiliğinden aydınlanır.`)
};

const zh_cn_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把光种进你的森林，照亮前途一片光明。`)
};

const zh_tw_daily_paywall_exclusive_tree_light_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`將光種進你的森林，點亮前途一片光明。`)
};

/**
* | output |
* | --- |
* | "When your focus is clear, the path lights itself." |
*
* @param {Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_light_subtitle = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_Light_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_light_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_light_subtitle(inputs)
	return zh_tw_daily_paywall_exclusive_tree_light_subtitle(inputs)
});